import { Children, addons } from 'react';

import { Component, fromJS } from 'core';

class Inherits extends Component {

    render() {

        const { children } = this.props;

        return (
            <div>
                { Children.map( children, Child => addons.cloneWithProps(Child, this.props) ) }
            </div>
        );
    }
}

export default Inherits;



// WEBPACK FOOTER //
// ./ui/gui/components/inherits.jsx